import { createBrowserRouter } from 'react-router-dom';

import { ROUTING } from './routes';

export default createBrowserRouter(ROUTING);
